// extracted by mini-css-extract-plugin
export default {"signIn":"BVE_A","loginButtonInner":"wDfgd","loginButtonLabel":"gTtHn"};